import React from "react";

const NotFound = () => {
  return (
    <li className="not-found">
      <h3>I'm Sorry. We don't have any of those pictures.</h3>
    </li>
  );
};

export default NotFound;